import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-social-media-link-header-facebook',
    templateUrl: './social-media-link-header-facebook.component.html',
    styleUrl: './social-media-link-header-facebook.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SocialMediaLinkHeaderFacebookComponent implements OnInit{
  public componentData: CmsLinkComponent;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
